<div class="min-h-screen bg-gradient-to-br from-[#2c5f8d] via-[#4A90E2] to-[#5ba3ef] flex items-center justify-center p-4">
  <div class="w-full max-w-md">
    <!-- Header com Logo e Título -->
    <div class="text-center mb-8">
      <div class="flex justify-center mb-6">
        <img src="https://zoomeduca.com.br/logo.svg" alt="ZoomEduca Logo" class="w-32 h-auto mx-auto brightness-0 invert drop-shadow-lg" />
      </div>
      <h1 class="text-2xl sm:text-3xl font-bold text-white mb-2 drop-shadow-lg text-balance leading-tight px-4">
        Portal de Concursos e<br/>Processos Seletivos
      </h1>
      <div class="h-1 w-24 bg-white/40 rounded-full mx-auto"></div>
    </div>

    <!-- Login Card -->
    <div class="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 backdrop-blur-sm">
      <h2 class="text-2xl font-bold text-gray-900 mb-6">Entrar</h2>

      <!-- Error Message -->
      <div *ngIf="errorMessage" class="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
        <div class="flex items-center gap-2">
          <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p class="text-sm text-red-800">{{ errorMessage }}</p>
        </div>
      </div>

      <form (ngSubmit)="onSubmit()" class="space-y-5">
        <!-- Regular Login Step -->
        <div class="space-y-5">
          <!-- CPF ou Email -->
          <div>
            <label for="email" class="block text-sm font-medium text-gray-900 mb-2">CPF ou E-mail</label>
            <input
              type="text"
              id="email"
              [(ngModel)]="loginData.email"
              name="email"
              required
              placeholder="Digite seu e-mail ou CPF"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A90E2] focus:border-transparent transition-colors"
            />
          </div>

          <!-- Senha -->
          <div>
            <label for="senha" class="block text-sm font-medium text-gray-900 mb-2">Senha</label>
            <div class="relative">
              <input
                [type]="showPassword ? 'text' : 'password'"
                id="senha"
                [(ngModel)]="loginData.senha"
                name="senha"
                required
                placeholder="Digite sua senha"
                class="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4A90E2] focus:border-transparent transition-colors"
              />
              <button
                type="button"
                (click)="togglePassword()"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
              >
                <svg *ngIf="!showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                <svg *ngIf="showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Lembrar e Esqueci Senha -->
          <div class="flex items-center justify-end">
            <a routerLink="/recuperar-senha" class="text-sm text-[#4A90E2] hover:text-[#2c5f8d] font-medium transition-colors">
              Esqueci minha senha
            </a>
          </div>
        </div>

        <!-- Botão Login -->
        <button
          type="submit"
          [disabled]="isLoading"
          class="w-full bg-[#4A90E2] text-white py-3 px-6 rounded-lg font-semibold hover:bg-[#3a7fc2] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          <svg *ngIf="isLoading" class="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span>{{ isLoading ? 'Entrando...' : 'Entrar' }}</span>
        </button>

        <!-- Divider -->
        <div class="relative my-6">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-gray-300"></div>
          </div>
          <div class="relative flex justify-center text-sm">
            <span class="px-2 bg-white text-gray-500">Primeira vez aqui?</span>
          </div>
        </div>

        <!-- Cadastro -->
        <a
        app-button
        routerLink="/cadastro"
        variant="outline"
        className="!border-[#4A90E2] !text-[#4A90E2] !font-semibold !hover:bg-blue-50 transition-colors"
        >
          Criar Conta
        </a>
      </form>
    </div>

    <!-- Footer Links -->
    <div class="mt-8 text-center">
      <a routerLink="/portal" class="text-white/95 hover:text-white text-sm font-medium inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg hover:bg-white/20 transition-all">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        Voltar ao Portal
      </a>
    </div>
  </div>
</div>
